import { Flex, Text, type FlexProps } from '@mantine/core';
import {
  DatePickerInput,
  type DatePickerInputProps,
  type DatePickerType,
} from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';
import classes from './FormDataRange.module.scss';

interface FormDataRangeProps {
  title: string;
  description: string;
  containerProps?: FlexProps;
  propsFromInput?: DatePickerInputProps<DatePickerType>;
  propsToInput?: DatePickerInputProps<DatePickerType>;
}

export const FormDataRange = ({
  title,
  description,
  containerProps,
  propsFromInput,
  propsToInput,
}: FormDataRangeProps) => {
  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        <Text className={classes.title}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Flex>
      <Flex className={classes.rightColumn} gap={16}>
        <DatePickerInput
          placeholder='c'
          variant='filled'
          className={classes.datePickerInput}
          leftSection={<IconCalendar color='var(--mantine-color-primary-7)' />}
          {...propsFromInput}
        />
        <DatePickerInput
          placeholder='до'
          variant='filled'
          className={classes.datePickerInput}
          leftSection={<IconCalendar color='var(--mantine-color-primary-7)' />}
          {...propsToInput}
        />
      </Flex>
    </Flex>
  );
};
